@if (order && PaymentType.PURCHASE === transaction.type && transaction.purposeId) {
  <ap-panel *apSecure='[Permissions.ACCESS_ALL_ORDERS]'>
    <ap-panel-content>
      <div class='form-horizontal form-label-left'>
        <div class='row'>
          <!-- GENERAL ORDER INFORMATIONS -->
          <div class='col-sm-12 col-md-12 col-xs-12'>
            <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.TITLE' | translate }}</span>
          </div>
          <div class='col-sm-6 col-md-6 col-xs-6 general-order-informations'>
            <!-- ORDER REFERENCE -->
            <div class='form-group'>
              <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.GENERAL_INFORMATIONS.REFERENCE' | translate }}</label>
              <div class='col-sm-7 col-md-7 col-xs-7'>{{ order.reference | noData }}</div>
            </div>
            <!-- ORDER CREATION DATE -->
            <div class='form-group'>
              <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.GENERAL_INFORMATIONS.CREATION_DATE' | translate }}</label>
              <div class='col-sm-7 col-md-7 col-xs-7'>{{ order.creationDate | date: "dd/MM/yyyy 'à' HH':'mm" | noData }}</div>
            </div>
            <!-- ORDER USER -->
            <div class='form-group'>
              @if (order?.mobilityAccountId) {
                <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.GENERAL_INFORMATIONS.USER' | translate }}</label>
                <div class='col-sm-7 col-md-7 col-xs-7'>
                  <code>{{ order.mobilityAccountId }}</code>
                  <button (click)='navigateToUser(order.mobilityAccountId)' class='btn btn-xs btn-default user-button-dialog'><i class='fa fa-user'></i></button>
                </div>
              } @else {
                <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.GENERAL_INFORMATIONS.ANONYMOUS_ORDER' | translate }}</label>
                <div class='col-sm-7 col-md-7 col-xs-7'>{{ order.customerReference | noData }}</div>
              }
            </div>
          </div>
          <!-- ORDER ITEMS -->
          @if (order.orderItems && order.orderItems.length > 0) {
            <div class='col-sm-12 col-md-12 col-xs-12'>
              <label class='order-items-label'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.TITLE' | translate }}</label>
              <div class='table-responsive order-items-array'>
                <table mat-table #orderTable [dataSource]='order.orderItems' id='datatable' class='table table-hover table-bordered table-fixed no-footer' role='grid' aria-describedby='datatable_info'>
                  <!-- LABEL -->
                  <ng-container matColumnDef='{{ orderItemColumns[0] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[0] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>{{ (orderItem.reference ? orderItem.reference + ' ' : '') + orderItem.label | noData }}</td>
                    <td mat-footer-cell *matFooterCellDef [attr.colspan]='6'></td>
                  </ng-container>
                  <!-- SERVICE PROVIDER -->
                  <ng-container matColumnDef='{{ orderItemColumns[1] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[1] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>{{ orderItem.serviceProvider | noData }}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <!-- QUANTITY -->
                  <ng-container matColumnDef='{{ orderItemColumns[2] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[2] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>{{ orderItem.quantity | noData }}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <!-- UNITARY AMOUNT EXCLUDING TAX -->
                  <ng-container matColumnDef='{{ orderItemColumns[3] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[3] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>{{ orderItem.unitaryAmountExclTax | apCurrency | noData }}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <!-- TAX -->
                  <ng-container matColumnDef='{{ orderItemColumns[4] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[4] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>{{ orderItem.taxRate ? orderItem.taxRate * 100 + '%' : '' | noData }}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <!-- UNITARY AMOUNT -->
                  <ng-container matColumnDef='{{orderItemColumns[5]}}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[5] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>{{ orderItem.unitaryAmount | apCurrency | noData }}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <!-- TOTAL AMOUNT EXCLUDING TAX -->
                  <ng-container matColumnDef='{{ orderItemColumns[6] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[6] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>{{ orderItem.totalAmountExclTax | apCurrency | noData }}</td>
                    <td mat-footer-cell *matFooterCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.FOOTER.TOTAL' | translate }}</td>
                  </ng-container>
                  <!-- TOTAL AMOUNT -->
                  <ng-container matColumnDef='{{ orderItemColumns[7] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[7] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>{{ orderItem.totalAmount | apCurrency | noData }}</td>
                    <td mat-footer-cell *matFooterCellDef>{{ order.totalAmount | apCurrency | noData }}</td>
                  </ng-container>
                  <!-- REFUND STATE -->
                  <ng-container matColumnDef='{{ orderItemColumns[8] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[8] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>
                      @if (orderItem.quantityRefunded) {
                        <status-label type='TRANSACTIONS.TYPE' status='REFUND'></status-label>
                      } @else {
                        -
                      }
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <!-- ACTIONS -->
                  <ng-container matColumnDef='{{ orderItemColumns[9] }}'>
                    <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.COLUMNS.' + orderItemColumns[9] | translate }}</th>
                    <td mat-cell *matCellDef='let orderItem'>@if (orderItem.description || (orderItem.additionalInformation && orderItem.additionalInformation.size > 0)) {
                      <button (click)='showOrderItemDetails(orderItem)' class='btn btn-xs btn-default'>{{ 'TRANSACTIONS.LIST.BUTTONS.DETAILS' | translate }}</button>
                    }</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef='orderItemColumns'></tr>
                  <tr mat-row *matRowDef='let row; columns: orderItemColumns;' role='row' class='odd'></tr>
                  <tr mat-footer-row *matFooterRowDef="footerOrderItemColumns"></tr>
                </table>
              </div>
            </div>
          }
        </div>
      </div>
    </ap-panel-content>
  </ap-panel>
}
